export default "__VITE_ASSET__Ct8feslq__"